<template>
  <div class="upgrade-banner">
    <div class="text-icon-container">
      <div class="large-icon-wrapper">
        <UpgradeIcon
          width="18"
          height="18"
        />
      </div>
      <div class="text-container">
        <div class="text text_md text_w-600">{{ title }}</div>
        <div class="text text_sm-plus">{{ description }}</div>
      </div>
    </div>
    <TButton
      variant="brand"
      @click="handleOnUpgradeButtonClick"
    >
      Upgrade
    </TButton>
  </div>
</template>

<script>
import { TButton } from '@/components/base/TButton';

import UpgradeIcon from '@/assets/icons/optimized/upgrade_mobile.svg?inline';

export default {
  name: 'TUpgradeBannerLarge',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  components: {
    TButton,
    UpgradeIcon,
  },
  methods: {
    handleOnUpgradeButtonClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/mixins";

$padding-size: 8px;

.upgrade-banner {
  box-sizing: border-box;
  padding: 16px 20px;
  background-color: #f4f2fe;
  border: 1px solid #FFFFFF;
  display: flex;
  justify-content: center;
  gap: 16px;
  border-radius: 8px;
  flex-direction: column;
  width: 100%;

  @include media-lg() {
    flex-direction: row;
    align-items: center;
  }
}

.text-icon-container {
  display: flex;
  width: 100%;
  gap: 16px;
}

.large-icon-wrapper {
  padding: 12px;
  border-radius: 50%;
  background-color: #FFFFFF;
  height: fit-content;
}

.text-container {
  flex-grow: 1;
  text-align: left;
}
</style>
